import axios from 'axios';
import { AxiosUtils } from 'utils/service/axios';
import Configuration from '../configuration/configuration';

export const UnauthenticatedBackend = axios.create({
  baseURL: Configuration.backendUrl,
});

UnauthenticatedBackend.interceptors.request.use(AxiosUtils.injectCorrelationId);
